"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelectAsyncPaginate = require("react-select-async-paginate");
var _excluded = ["options", "value", "onChange", "onChangeHandler", "input", "loadOptions", "meta"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var NUMBER_OPTIONS_RENDER = 250;
var SelectLargeList = function SelectLargeList(props) {
  var options = props.options,
    value = props.value,
    onChange = props.onChange,
    onChangeHandler = props.onChangeHandler,
    input = props.input,
    loadOptions = props.loadOptions,
    meta = props.meta,
    commonProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    finalValueToUse = _useState2[0],
    setFinalValueToUse = _useState2[1];
  var flossedOptions = options && options.filter(function (option, ind, arr) {
    return option && (option.value || option.value === 0) && ind === arr.findIndex(function (child) {
      return option.value === child.value;
    });
  });
  var initialValue = value || input.value;
  var assigneeData = initialValue && flossedOptions.filter(function (arr) {
    return arr.value === initialValue;
  });
  var onSelectValue = function onSelectValue(selectedValue) {
    if (input && input.onChange) {
      input.onChange(selectedValue && selectedValue.value);
    }
    assigneeData = null;
    onChangeHandler(selectedValue && selectedValue.value);
    setFinalValueToUse(selectedValue);
  };

  // handle static, large list of options
  var loadOptionsStatic = function loadOptionsStatic(search, prevOptions) {
    var filteredOptions;
    if (!search) {
      filteredOptions = flossedOptions;
    } else {
      var searchLower = search.toLowerCase();
      filteredOptions = flossedOptions.filter(function (_ref) {
        var label = _ref.label;
        return typeof label === 'string' && label.toLowerCase().includes(searchLower);
      });
    }
    var hasMore = filteredOptions.length > prevOptions.length + NUMBER_OPTIONS_RENDER;
    var slicedOptions = filteredOptions.slice(prevOptions.length, prevOptions.length + NUMBER_OPTIONS_RENDER);
    return {
      options: slicedOptions,
      hasMore: hasMore
    };
  };
  return /*#__PURE__*/_react.default.createElement(_reactSelectAsyncPaginate.AsyncPaginate, (0, _extends2.default)({}, commonProps, {
    value: value || finalValueToUse || assigneeData || '',
    onChange: meta ? onSelectValue : onChange,
    loadOptions: loadOptions || loadOptionsStatic
  }));
};
SelectLargeList.propTypes = {
  loadOptions: _propTypes.default.func,
  options: _propTypes.default.instanceOf(Array),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape({})]),
  onChange: _propTypes.default.func,
  onChangeHandler: _propTypes.default.func,
  input: _propTypes.default.shape({
    value: _propTypes.default.number,
    onChange: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    onDragStart: _propTypes.default.func,
    onDrop: _propTypes.default.func,
    onFocus: _propTypes.default.func
  }),
  /** For use with redux-form */
  meta: _propTypes.default.shape({})
};
SelectLargeList.defaultProps = {
  loadOptions: null,
  options: [],
  value: null,
  input: {
    value: null,
    onBlur: null,
    onDragStart: null,
    onDrop: null,
    onFocus: null
  },
  meta: null,
  onChange: null,
  onChangeHandler: null
};
var _default = SelectLargeList;
exports.default = _default;